import { Component } from '@angular/core';

@Component({
  selector: 'app-administrador-productos-upload-batch',
  templateUrl: './administrador-productos-upload-batch.component.html',
  styleUrls: ['./administrador-productos-upload-batch.component.scss']
})
export class AdministradorProductosUploadBatchComponent {
    constructor(){}
}
